import { isDefined } from "@clipboard-health/util-ts";
import { SvgIcon, type SvgIconProps, type Theme } from "@mui/material";
import type { SVGProps } from "react";

import Airplane from "../../icons/Airplane";
import AirplaneGlobe from "../../icons/AirplaneGlobe";
import AirplaneTakeoff from "../../icons/AirplaneTakeoff";
import AmericanExpressColored from "../../icons/AmericanExpressColored";
import ArrowDown from "../../icons/ArrowDown";
import ArrowLeft from "../../icons/ArrowLeft";
import ArrowRight from "../../icons/ArrowRight";
import ArrowUp from "../../icons/ArrowUp";
import ArrowUpRightFromSquare from "../../icons/ArrowUpRightFromSquare";
import Badge from "../../icons/Badge";
import Bank from "../../icons/Bank";
import BellOutlined from "../../icons/BellOutlined";
import BlockShift from "../../icons/BlockShift";
import Bolt from "../../icons/Bolt";
import BoltFilled from "../../icons/BoltFilled";
import Break from "../../icons/Break";
import Briefcase from "../../icons/Briefcase";
import BriefcaseColored from "../../icons/BriefcaseColored";
import BriefcaseFilled from "../../icons/BriefcaseFilled";
import Building from "../../icons/Building";
import CalendarClock from "../../icons/CalendarClock";
import CalendarNavigation from "../../icons/CalendarNavigation";
import CalendarRemove from "../../icons/CalendarRemove";
import CalendarWithCells from "../../icons/CalendarWithCells";
import CalendarWithCircleColored from "../../icons/CalendarWithCircleColored";
import CameraFilled from "../../icons/CameraFilled";
import Car from "../../icons/Car";
import CarFilled from "../../icons/CarFilled";
import CbhBunnyColored from "../../icons/CbhBunnyColored";
import Chat from "../../icons/Chat";
import ChatColored from "../../icons/ChatColored";
import ChatFilled from "../../icons/ChatFilled";
import ChatWithGradient from "../../icons/ChatWithGradient";
import Checkmark from "../../icons/Checkmark";
import CheckmarkDouble from "../../icons/CheckmarkDouble";
import CheckmarkFilled from "../../icons/CheckmarkFilled";
import CheckmarkIllustration from "../../icons/CheckmarkIllustration";
import ChevronDown from "../../icons/ChevronDown";
import ChevronLeft from "../../icons/ChevronLeft";
import ChevronRight from "../../icons/ChevronRight";
import ChevronUp from "../../icons/ChevronUp";
import Clipboard from "../../icons/Clipboard";
import ClipboardBunnyColored from "../../icons/ClipboardBunnyColored";
import ClipboardScoreCancellationColored from "../../icons/ClipboardScoreCancellationColored";
import ClipboardScoreGoalProgressColored from "../../icons/ClipboardScoreGoalProgressColored";
import ClipboardScoreGoalReachedColored from "../../icons/ClipboardScoreGoalReachedColored";
import ClipboardScoreHealthyColored from "../../icons/ClipboardScoreHealthyColored";
import ClipboardScoreRestrictionColored from "../../icons/ClipboardScoreRestrictionColored";
import ClipboardScoreUnhealthyColored from "../../icons/ClipboardScoreUnhealthyColored";
import ClipboardWithNotes from "../../icons/ClipboardWithNotes";
import ClipboardWithNotesColored from "../../icons/ClipboardWithNotesColored";
import ClipboardWithNotesFilled from "../../icons/ClipboardWithNotesFilled";
import Clock from "../../icons/Clock";
import ClockErrorWithExclamationColored from "../../icons/ClockErrorWithExclamationColored";
import ClockFilled from "../../icons/ClockFilled";
import ClockHistory from "../../icons/ClockHistory";
import ClockSuccessWithDollarColored from "../../icons/ClockSuccessWithDollarColored";
import Close from "../../icons/Close";
import Coin from "../../icons/Coin";
import CoinFilled from "../../icons/CoinFilled";
import Compass from "../../icons/Compass";
import CompassFilled from "../../icons/CompassFilled";
import Copy from "../../icons/Copy";
import CreditCard from "../../icons/CreditCard";
import CrossedBadge from "../../icons/CrossedBadge";
import DateClock from "../../icons/DateClock";
import Devices from "../../icons/Devices";
import Diamond from "../../icons/Diamond";
import DiamondColored from "../../icons/DiamondColored";
import Document from "../../icons/Document";
import DocumentFolder from "../../icons/DocumentFolder";
import DocumentGreenColored from "../../icons/DocumentGreenColored";
import DocumentIdOutlined from "../../icons/DocumentIdOutlined";
import DocumentLens from "../../icons/DocumentLens";
import DocumentPlus from "../../icons/DocumentPlus";
import DocumentSearch from "../../icons/DocumentSearch";
import DocumentUser from "../../icons/DocumentUser";
import Dollar from "../../icons/Dollar";
import DollarErrorColored from "../../icons/DollarErrorColored";
import DollarInfoColored from "../../icons/DollarInfoColored";
import DollarWarningColored from "../../icons/DollarWarningColored";
import DollarWithCircle from "../../icons/DollarWithCircle";
import Dot from "../../icons/Dot";
import Download from "../../icons/Download";
import DressCode from "../../icons/DressCode";
import Ellipsis from "../../icons/Ellipsis";
import Email from "../../icons/Email";
import EmailFilled from "../../icons/EmailFilled";
import Exit from "../../icons/Exit";
import ExtraPay from "../../icons/ExtraPay";
import Eye from "../../icons/Eye";
import EyeSlash from "../../icons/EyeSlash";
import Folder from "../../icons/Folder";
import GiftLavenderColored from "../../icons/GiftLavenderColored";
import GiftOutlined from "../../icons/GiftOutlined";
import GoldBadgeColored from "../../icons/GoldBadgeColored";
import HelpOutlined from "../../icons/HelpOutlined";
import Hourglass from "../../icons/Hourglass";
import HourglassIllustration from "../../icons/HourglassIllustration";
import House from "../../icons/House";
import HouseFilled from "../../icons/HouseFilled";
import HouseIllustration from "../../icons/HouseIllustration";
import Info from "../../icons/Info";
import IntroductionVideo from "../../icons/IntroductionVideo";
import Invite from "../../icons/Invite";
import LightbulbGray from "../../icons/LightbulbGray";
import LikeFilled from "../../icons/LikeFilled";
import LikeOutlined from "../../icons/LikeOutlined";
import List from "../../icons/List";
import Locked from "../../icons/Locked";
import LockedFilled from "../../icons/LockedFilled";
import LockWithStarGreen from "../../icons/LockWithStarGreen";
import LockWithStarViolet from "../../icons/LockWithStarViolet";
import MapPaper from "../../icons/MapPaper";
import MapPin from "../../icons/MapPin";
import MastercardColored from "../../icons/MastercardColored";
import MembershipGoldColored from "../../icons/MembershipGoldColored";
import MembershipGreenColored from "../../icons/MembershipGreenColored";
import MembershipLimitedColored from "../../icons/MembershipLimitedColored";
import MembershipRedColored from "../../icons/MembershipRedColored";
import MembershipSilverColored from "../../icons/MembershipSilverColored";
import Minus from "../../icons/Minus";
import MoonFilled from "../../icons/MoonFilled";
import MoonOutlined from "../../icons/MoonOutlined";
import NavigationArrow from "../../icons/NavigationArrow";
import New from "../../icons/New";
import OldPhone from "../../icons/OldPhone";
import PaperAirplane from "../../icons/PaperAirplane";
import Paperclip from "../../icons/Paperclip";
import Parachute from "../../icons/Parachute";
import Passkeys from "../../icons/Passkeys";
import Patients from "../../icons/Patients";
import PatientsFilled from "../../icons/PatientsFilled";
import Pencil from "../../icons/Pencil";
import Phone from "../../icons/Phone";
import Plane from "../../icons/Plane";
import Plus from "../../icons/Plus";
import Priority from "../../icons/Priority";
import Privacy from "../../icons/Privacy";
import QrCode from "../../icons/QrCode";
import RebrandBriefcaseColored from "../../icons/RebrandBriefcaseColored";
import RebrandChatColored from "../../icons/RebrandChatColored";
import RebrandClipboardWithNotesColored from "../../icons/RebrandClipboardWithNotesColored";
import RebrandSearchColored from "../../icons/RebrandSearchColored";
import RebrandUserColored from "../../icons/RebrandUserColored";
import Refresh from "../../icons/Refresh";
import Remove from "../../icons/Remove";
import RestrictedBadgeColored from "../../icons/RestrictedBadgeColored";
import Resume from "../../icons/Resume";
import ScallopedDiamondWithStarColored from "../../icons/ScallopedDiamondWithStarColored";
import ScallopedUserBadgeWithStarColored from "../../icons/ScallopedUserBadgeWithStarColored";
import School from "../../icons/School";
import Search from "../../icons/Search";
import SearchColored from "../../icons/SearchColored";
import SearchFilled from "../../icons/SearchFilled";
import Share from "../../icons/Share";
import SilverBadgeColored from "../../icons/SilverBadgeColored";
import SliderSettings from "../../icons/SliderSettings";
import Software from "../../icons/Software";
import Star from "../../icons/Star";
import StarFilled from "../../icons/StarFilled";
import StopWatch from "../../icons/StopWatch";
import Suitcase from "../../icons/Suitcase";
import SunFilled from "../../icons/SunFilled";
import SunOutlined from "../../icons/SunOutlined";
import SunsetFilled from "../../icons/SunsetFilled";
import SunsetOutlined from "../../icons/SunsetOutlined";
import Supplies from "../../icons/Supplies";
import SwapHorizontal from "../../icons/SwapHorizontal";
import TextBubble from "../../icons/TextBubble";
import TextBubbleFilled from "../../icons/TextBubbleFilled";
import TimeFlies from "../../icons/TimeFlies";
import Trash from "../../icons/Trash";
import TrendingDown from "../../icons/TrendingDown";
import TrendingUp from "../../icons/TrendingUp";
import TrendingUpBars from "../../icons/TrendingUpBars";
import TriangleExclamation from "../../icons/TriangleExclamation";
import Unlock from "../../icons/Unlock";
import User from "../../icons/User";
import UserAdd from "../../icons/UserAdd";
import UserColored from "../../icons/UserColored";
import UserFilled from "../../icons/UserFilled";
import UserGroup from "../../icons/UserGroup";
import UserMini from "../../icons/UserMini";
import UserRemove from "../../icons/UserRemove";
import UsersFilled from "../../icons/UsersFilled";
import UserStarred from "../../icons/UserStarred";
import VerifiedColored from "../../icons/VerifiedColored";
import VideoOutlined from "../../icons/VideoOutlined";
import VisaColored from "../../icons/VisaColored";
import Wallet from "../../icons/Wallet";
import { mergeSxProps } from "../../lib/mergeSxProps";

/**
 * Icon size options from smallest to largest
 * @typedef IconSize
 */
export const ICON_SIZES = ["xSmall", "small", "medium", "large", "xLarge"] as const;
export type IconSize = (typeof ICON_SIZES)[number];

export const ICON_TYPES = [
  "airplane",
  "airplane-globe",
  "airplane-takeoff",
  "american-express-colored",
  "arrow-down",
  "arrow-left",
  "arrow-right",
  "arrow-up",
  "arrow-up-right-from-square",
  "badge",
  "bank",
  "bell-outlined",
  "block-shift",
  "bolt",
  "bolt-filled",
  "break",
  "briefcase",
  "briefcase-colored",
  "briefcase-filled",
  "building",
  "calendar-clock",
  "calendar-navigation",
  "calendar-remove",
  "calendar-with-cells",
  "calendar-with-circle-colored",
  "camera-filled",
  "car",
  "car-filled",
  "cbh-bunny-colored",
  "chat",
  "chat-colored",
  "chat-filled",
  "chat-with-gradient",
  "checkmark",
  "checkmark-double",
  "checkmark-filled",
  "checkmark-illustration",
  "chevron-down",
  "chevron-left",
  "chevron-right",
  "chevron-up",
  "clipboard",
  "clipboard-bunny-colored",
  "clipboard-score-cancellation-colored",
  "clipboard-score-goal-progress-colored",
  "clipboard-score-goal-reached-colored",
  "clipboard-score-healthy-colored",
  "clipboard-score-restriction-colored",
  "clipboard-score-unhealthy-colored",
  "clipboard-with-notes",
  "clipboard-with-notes-colored",
  "clipboard-with-notes-filled",
  "clock",
  "clock-error-with-exclamation-colored",
  "clock-filled",
  "clock-history",
  "clock-success-with-dollar-colored",
  "close",
  "coin",
  "coin-filled",
  "compass",
  "compass-filled",
  "copy",
  "credit-card",
  "crossed-badge",
  "date-clock",
  "devices",
  "diamond",
  "diamond-colored",
  "dollar",
  "dollar-info-colored",
  "dollar-warning-colored",
  "dollar-error-colored",
  "dollar-with-circle",
  "dot",
  "document",
  "document-folder",
  "document-plus",
  "document-search",
  "document-id-outlined",
  "document-lens",
  "document-user",
  "download",
  "dress-code",
  "email",
  "email-filled",
  "exit",
  "extra-pay",
  "eye",
  "eye-slash",
  "folder",
  "gift-lavender-colored",
  "gift-outlined",
  "gold-badge-colored",
  "hourglass",
  "hourglass-illustration",
  "house",
  "house-filled",
  "house-illustration",
  "info",
  "help-outlined",
  "introduction-video",
  "invite",
  "ellipsis",
  "lightbulb-gray",
  "like-filled",
  "like-outlined",
  "list",
  "locked",
  "locked-filled",
  "lock-with-star-green",
  "lock-with-star-violet",
  "map-pin",
  "map-paper",
  "mastercard-colored",
  "membership-gold-colored",
  "membership-green-colored",
  "membership-red-colored",
  "membership-limited-colored",
  "membership-silver-colored",
  "minus",
  "moon-filled",
  "moon-outlined",
  "navigation-arrow",
  "new",
  "old-phone",
  "paper-airplane",
  "paperclip",
  "parachute",
  "passkeys",
  "patients",
  "patients-filled",
  "pencil",
  "phone",
  "plane",
  "plus",
  "priority",
  "privacy",
  "qr-code",
  "rebrand-chat-colored",
  "rebrand-briefcase-colored",
  "rebrand-search-colored",
  "rebrand-clipboard-with-notes-colored",
  "rebrand-user-colored",
  "refresh",
  "remove",
  "resume",
  "restricted-badge-colored",
  "scalloped-diamond-with-star-colored",
  "scalloped-user-badge-with-star-colored",
  "school",
  "search",
  "search-colored",
  "search-filled",
  "share",
  "silver-badge-colored",
  "slider-settings",
  "software",
  "star-filled",
  "star",
  "stop-watch",
  "suitcase",
  "sun-filled",
  "sun-outlined",
  "sunset-filled",
  "sunset-outlined",
  "supplies",
  "swap-horizontal",
  "text-bubble",
  "text-bubble-filled",
  "time-flies",
  "trending-down",
  "trending-up",
  "trending-up-bars",
  "trash",
  "triangle-exclamation",
  "unlock",
  "user-add",
  "user-colored",
  "user-filled",
  "user-group",
  "user-mini",
  "user-remove",
  "user-starred",
  "users-filled",
  "user",
  "verified-colored",
  "video-outlined",
  "visa-colored",
  "document-green-colored",
  "wallet",
] as const;

export type IconType = (typeof ICON_TYPES)[number];

const iconMap: Record<
  IconType,
  React.ForwardRefExoticComponent<
    Omit<SVGProps<SVGSVGElement>, "ref"> & React.RefAttributes<SVGSVGElement>
  >
> = {
  airplane: Airplane,
  "airplane-globe": AirplaneGlobe,
  "airplane-takeoff": AirplaneTakeoff,
  "american-express-colored": AmericanExpressColored,
  "arrow-down": ArrowDown,
  "arrow-left": ArrowLeft,
  "arrow-right": ArrowRight,
  "arrow-up": ArrowUp,
  "arrow-up-right-from-square": ArrowUpRightFromSquare,
  badge: Badge,
  bank: Bank,
  "bell-outlined": BellOutlined,
  "block-shift": BlockShift,
  bolt: Bolt,
  "bolt-filled": BoltFilled,
  break: Break,
  briefcase: Briefcase,
  "briefcase-colored": BriefcaseColored,
  "briefcase-filled": BriefcaseFilled,
  building: Building,
  "calendar-clock": CalendarClock,
  "calendar-navigation": CalendarNavigation,
  "calendar-remove": CalendarRemove,
  "calendar-with-cells": CalendarWithCells,
  "calendar-with-circle-colored": CalendarWithCircleColored,
  car: Car,
  "camera-filled": CameraFilled,
  "cbh-bunny-colored": CbhBunnyColored,
  "car-filled": CarFilled,
  chat: Chat,
  "chat-colored": ChatColored,
  "chat-filled": ChatFilled,
  "chat-with-gradient": ChatWithGradient,
  checkmark: Checkmark,
  "checkmark-double": CheckmarkDouble,
  "checkmark-filled": CheckmarkFilled,
  "checkmark-illustration": CheckmarkIllustration,
  "clock-filled": ClockFilled,
  "chevron-down": ChevronDown,
  "chevron-left": ChevronLeft,
  "chevron-right": ChevronRight,
  "chevron-up": ChevronUp,
  clipboard: Clipboard,
  "clipboard-bunny-colored": ClipboardBunnyColored,
  "clipboard-score-cancellation-colored": ClipboardScoreCancellationColored,
  "clipboard-score-goal-progress-colored": ClipboardScoreGoalProgressColored,
  "clipboard-score-goal-reached-colored": ClipboardScoreGoalReachedColored,
  "clipboard-score-healthy-colored": ClipboardScoreHealthyColored,
  "clipboard-score-restriction-colored": ClipboardScoreRestrictionColored,
  "clipboard-score-unhealthy-colored": ClipboardScoreUnhealthyColored,
  "clipboard-with-notes": ClipboardWithNotes,
  "clipboard-with-notes-colored": ClipboardWithNotesColored,
  "clipboard-with-notes-filled": ClipboardWithNotesFilled,
  clock: Clock,
  "clock-error-with-exclamation-colored": ClockErrorWithExclamationColored,
  "clock-history": ClockHistory,
  "clock-success-with-dollar-colored": ClockSuccessWithDollarColored,
  close: Close,
  coin: Coin,
  "coin-filled": CoinFilled,
  compass: Compass,
  "compass-filled": CompassFilled,
  copy: Copy,
  "credit-card": CreditCard,
  "crossed-badge": CrossedBadge,
  "date-clock": DateClock,
  devices: Devices,
  diamond: Diamond,
  "diamond-colored": DiamondColored,
  dollar: Dollar,
  "dollar-info-colored": DollarInfoColored,
  "dollar-warning-colored": DollarWarningColored,
  "dollar-error-colored": DollarErrorColored,
  "dollar-with-circle": DollarWithCircle,
  dot: Dot,
  document: Document,
  "document-folder": DocumentFolder,
  "document-plus": DocumentPlus,
  "document-search": DocumentSearch,
  "document-id-outlined": DocumentIdOutlined,
  "document-lens": DocumentLens,
  "document-user": DocumentUser,
  "document-green-colored": DocumentGreenColored,
  "dress-code": DressCode,
  download: Download,
  email: Email,
  "email-filled": EmailFilled,
  exit: Exit,
  "extra-pay": ExtraPay,
  eye: Eye,
  "eye-slash": EyeSlash,
  folder: Folder,
  "gift-lavender-colored": GiftLavenderColored,
  "gift-outlined": GiftOutlined,
  "gold-badge-colored": GoldBadgeColored,
  hourglass: Hourglass,
  "hourglass-illustration": HourglassIllustration,
  house: House,
  "house-filled": HouseFilled,
  "house-illustration": HouseIllustration,
  info: Info,
  "help-outlined": HelpOutlined,
  "introduction-video": IntroductionVideo,
  invite: Invite,
  ellipsis: Ellipsis,
  "lightbulb-gray": LightbulbGray,
  "like-filled": LikeFilled,
  "like-outlined": LikeOutlined,
  list: List,
  "map-paper": MapPaper,
  "map-pin": MapPin,
  locked: Locked,
  "locked-filled": LockedFilled,
  "lock-with-star-green": LockWithStarGreen,
  "lock-with-star-violet": LockWithStarViolet,
  "mastercard-colored": MastercardColored,
  "membership-gold-colored": MembershipGoldColored,
  "membership-green-colored": MembershipGreenColored,
  "membership-red-colored": MembershipRedColored,
  "membership-limited-colored": MembershipLimitedColored,
  "membership-silver-colored": MembershipSilverColored,
  minus: Minus,
  "moon-filled": MoonFilled,
  "moon-outlined": MoonOutlined,
  "navigation-arrow": NavigationArrow,
  new: New,
  "old-phone": OldPhone,
  "paper-airplane": PaperAirplane,
  paperclip: Paperclip,
  parachute: Parachute,
  passkeys: Passkeys,
  patients: Patients,
  "patients-filled": PatientsFilled,
  pencil: Pencil,
  phone: Phone,
  plane: Plane,
  plus: Plus,
  priority: Priority,
  privacy: Privacy,
  "qr-code": QrCode,
  "rebrand-chat-colored": RebrandChatColored,
  "rebrand-briefcase-colored": RebrandBriefcaseColored,
  "rebrand-search-colored": RebrandSearchColored,
  "rebrand-clipboard-with-notes-colored": RebrandClipboardWithNotesColored,
  "rebrand-user-colored": RebrandUserColored,
  remove: Remove,
  refresh: Refresh,
  "restricted-badge-colored": RestrictedBadgeColored,
  resume: Resume,
  "scalloped-diamond-with-star-colored": ScallopedDiamondWithStarColored,
  "scalloped-user-badge-with-star-colored": ScallopedUserBadgeWithStarColored,
  school: School,
  search: Search,
  "search-colored": SearchColored,
  "search-filled": SearchFilled,
  share: Share,
  "silver-badge-colored": SilverBadgeColored,
  "slider-settings": SliderSettings,
  software: Software,
  star: Star,
  "star-filled": StarFilled,
  "stop-watch": StopWatch,
  suitcase: Suitcase,
  "sun-filled": SunFilled,
  "sun-outlined": SunOutlined,
  "sunset-filled": SunsetFilled,
  "sunset-outlined": SunsetOutlined,
  "swap-horizontal": SwapHorizontal,
  supplies: Supplies,
  "text-bubble": TextBubble,
  "text-bubble-filled": TextBubbleFilled,
  "time-flies": TimeFlies,
  "trending-down": TrendingDown,
  "trending-up": TrendingUp,
  "trending-up-bars": TrendingUpBars,
  trash: Trash,
  "triangle-exclamation": TriangleExclamation,
  unlock: Unlock,
  "user-add": UserAdd,
  "user-colored": UserColored,
  "user-filled": UserFilled,
  "user-group": UserGroup,
  "user-mini": UserMini,
  "user-remove": UserRemove,
  "user-starred": UserStarred,
  "users-filled": UsersFilled,
  user: User,
  "verified-colored": VerifiedColored,
  "video-outlined": VideoOutlined,
  "visa-colored": VisaColored,
  wallet: Wallet,
} as const;

export interface CbhIconProps extends Omit<SvgIconProps, "color"> {
  type: IconType;
  /**
   * xSmall: 0.75rem (12px)
   * small: 1rem (16px)
   * medium: 1.5rem (24px)
   * large: 2rem (32px)
   * xLarge: 3.5rem (56px)
   */
  size?: IconSize;
  color?: (theme: Theme) => string | undefined;
}

export function CbhIcon(props: CbhIconProps) {
  const { type, size = "medium", sx, color, ...restProps } = props;

  const IconComponent = iconMap[type];
  if (!isDefined(IconComponent)) {
    return null;
  }

  return (
    <SvgIcon
      {...restProps}
      sx={mergeSxProps(
        (theme) => ({
          width: theme.size?.icon[size],
          height: theme.size?.icon[size],
          color: isDefined(color) ? color?.(theme) : undefined,
        }),
        sx
      )}
    >
      <IconComponent />
    </SvgIcon>
  );
}
